var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 154,
    viewBox: "0 0 231 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.4328 136.861C74.1789 139.413 66.5567 140.762 58.8676 140.855C58.8676 140.855 57.0286 143.427 58.1343 148.572",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1499 146.722C40.1499 146.722 37.5774 137.905 41.2499 139.005C44.9224 140.105 53.373 142.683 53.373 142.683",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6278 152.786C86.5889 152.786 81.2918 147.179 80.3158 146.051L80.1466 145.864L61.6826 151.139C59.4347 151.782 57.0568 151.821 54.789 151.252L45.6388 148.995V150.389C45.1247 150.98 44.4045 151.353 43.6249 151.432H43.388C42.412 151.297 37.8934 149.012 35.5861 147.805L35.022 143.755L13.6471 134.65L14.0194 138.328L6.55604 135.507L5.45598 125.59L2.51123 124.303L1.24194 118.335L1.96403 116.163C3.26716 111.086 6.35294 100.982 8.80126 99.0305L8.94229 98.9177V98.7428C8.99306 97.8289 10.7532 89.3218 56.5491 71.8169L56.6563 71.7718L58.5235 69.0979L85.1053 46.9163C86.6284 46.2224 119.122 31.5438 139.747 31.5438C142.022 31.5189 144.293 31.7517 146.516 32.2377C153.59 33.9301 160.416 35.7692 166.825 37.7774L167.389 37.9467V37.738C167.846 37.738 168.687 37.6985 169.866 37.6985C178.831 37.7376 187.766 38.7324 196.521 40.6658L197.734 40.9366C209.016 43.4357 215.814 44.9475 219.735 48.1292C220.916 48.9426 221.846 50.07 222.42 51.3842C222.657 51.8237 222.869 52.2756 223.057 52.7381V52.7381L223.689 60.8729L224.101 60.8277C224.206 60.8211 224.312 60.8211 224.417 60.8277C224.863 60.8303 225.301 60.9386 225.697 61.1436C226.826 61.7078 227.756 63.0391 228.388 65.0925C229.116 67.445 229.477 68.844 229.466 69.2502H229.291L229.195 69.4645C226.656 74.9648 222.99 81.943 220.897 83.4944C218.042 85.6381 208.26 88.8536 207.843 88.989L207.594 89.068V89.3331C207.262 93.282 205.597 100.695 198.151 105.529C196.43 106.727 194.397 107.394 192.301 107.447V107.447C191.529 107.447 190.761 107.344 190.016 107.143C185.317 105.862 182.288 101.028 181.475 99.5777L181.131 98.9628L179.546 101.738L179.365 103.893L116.183 130.892V131.146C116.127 132.523 115.292 144.753 103.208 150.705C100.547 152.053 97.6104 152.765 94.6278 152.786Z",
    fill: "#FFDE00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M178.892 66.1249C178.892 66.1249 181.927 67.8455 183.371 62.176C184.815 56.5065 182.807 50.3293 173.521 51.2883C173.521 51.2883 163.88 50.3293 166.424 61.5554L166.013 62.1196C166.013 62.1196 160.71 52.5294 158.713 59.3666C156.716 66.2039 159.61 75.8279 159.61 75.8279L159.046 75.9689C159.046 75.9689 150.505 58.8138 144.581 64.8782C144.581 64.8782 142.099 68.184 141.687 70.5194C141.687 70.5194 137.693 65.2843 131.629 74.7899C130.101 77.3221 129.182 80.1743 128.944 83.1221C128.944 83.1221 128.532 96.8981 130.738 104.751C132.943 112.603 134.867 115.356 143.713 110.539C143.713 110.539 151.012 105.163 154.047 96.2099L154.183 95.3862C154.183 95.3862 160.388 101.592 164.518 99.5157L165.894 98.3479L167.682 93.801L168.579 88.2895L168.782 87.6013L170.853 89.666C170.853 89.666 175.93 96.2099 182.079 91.3189C182.079 91.3189 183.388 85.6042 186.485 81.7287L186.626 79.5229C185.308 74.4391 182.635 69.8084 178.892 66.1249V66.1249ZM146.528 86.9243L140.283 89.4008L139.82 89.3106C141.659 86.6479 143.205 81.1363 143.205 81.1363L146.511 86.3715L146.528 86.9243ZM168.314 71.7492C168.658 69.8199 166.938 64.3761 166.938 64.3761L167.835 64.7202C169.377 68.1227 171.603 71.1718 174.373 73.6786L168.314 71.7492Z",
    fill: "#FF2BFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131.804 73.6278C131.804 73.6278 136.21 61.7811 139.978 59.9477L148.62 55.2372L151.825 66.1926C151.825 66.1926 144.801 59.062 141.766 70.3559C141.766 70.3559 138.083 65.7413 132.78 73.0806C132.108 74.0058 132.825 72.3077 131.804 73.6278Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M181.03 98.3592C181.03 98.3592 184.471 107.385 192.047 107.724C192.047 107.724 203.002 107.588 207.2 92.4359C207.2 92.4359 211.058 70.8749 196.87 73.8196C182.683 76.7644 181.03 98.3592 181.03 98.3592Z",
    fill: "#231F20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.825 143.608C79.825 143.608 79.825 150.225 91.8523 152.634C91.8523 152.634 104.438 156.216 113.436 140.968C113.436 140.968 118.671 134.266 115.546 120.214C115.546 120.214 114.694 115.531 111.23 112.773C108.015 110.217 102.537 109.388 93.7816 113.969C93.7816 113.969 84.417 119.757 83.6273 129.443C83.6273 129.443 84.8627 134.52 81.9349 136.742C81.9349 136.72 81.2918 141.774 79.825 143.608Z",
    fill: "#231F20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9041 71.5631C60.9041 71.5631 32.1336 82.5862 18.7525 92.6389C18.7525 92.6389 11.8193 95.8545 13.4271 98.7936C13.4271 98.7936 48.4651 111.058 65.7726 119.001L67.1039 117.872L113.114 91.9733C113.114 91.9733 116.285 90.2301 115.185 89.9988C114.085 89.7675 63.3863 73.7914 63.3863 73.7914C63.3863 73.7914 60.4923 72.8211 60.9041 71.5631Z",
    fill: "#FF2BFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M177.447 41.3033C177.447 41.3033 166.063 36.7169 146.59 32.1192C127.116 27.5216 85.0376 46.8148 85.0376 46.8148L58.4051 69.0414L56.566 71.6082C7.54891 90.3429 8.83512 98.771 8.83512 98.771C5.70985 100.977 1.85683 116.039 1.85683 116.039L1.12347 118.239L2.40404 124.303L5.34316 125.59L6.47142 135.507L14.183 138.446L13.8164 134.774L34.9373 143.772L35.5015 147.811C35.5015 147.811 42.113 151.303 43.3993 151.489C44.6855 151.675 45.7855 150.361 45.7855 150.361V149.074L54.8116 151.331C57.0821 151.896 59.4611 151.855 61.7109 151.212L80.1353 145.949C80.1353 145.949 89.4378 157.548 103.265 150.722C116.285 144.347 116.285 130.926 116.285 130.926",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M166.977 37.6308C166.977 37.6308 180.02 36.8974 196.549 40.5699C213.078 44.2424 220.428 45.743 223.181 52.693L224.101 64.4494C224.101 64.4494 206.652 74.0001 206.099 74.5473",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M126.569 59.8461C131.161 61.1324 129.141 64.252 129.141 64.252C129.141 64.252 120.51 79.8671 119.41 85.1924C118.31 90.5178 115.185 89.965 115.185 89.965C115.185 89.965 63.2002 74.1694 61.7334 72.8831C60.2667 71.5969 62.1001 69.944 62.1001 69.944L83.9093 50.5662C84.3771 50.145 84.9412 49.845 85.552 49.6925C86.1628 49.5401 86.8016 49.5398 87.4125 49.6918L126.569 59.8461Z",
    fill: "#231F20"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1751 105.591L102.142 96.0406",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M115.185 90.8732C115.185 90.8732 68.7117 115.853 65.7726 118.978L54.2023 113.647L71.3123 107.357",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M223.734 60.7713C223.734 60.7713 226.859 59.6431 228.512 64.9966C230.165 70.3502 229.426 69.222 229.426 69.222C229.426 69.222 223.92 81.3451 220.964 83.5508C218.008 85.7566 207.944 89.0567 207.944 89.0567",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M214.736 45.5286C214.736 45.5286 220.101 48.5128 216.756 49.9344C214.11 51.0627 199.832 56.1793 199.832 56.1793C199.832 56.1793 222.059 49.4098 223.159 55.2654C223.181 55.2654 225.207 48.2815 214.736 45.5286Z",
    fill: "#231F20"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M179.839 43.1423C179.839 43.1423 194.896 52.1684 197.655 56.1793",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4494 112.936C51.4494 112.936 23.164 101.366 13.4271 98.771C13.4271 98.771 11.9547 96.5653 15.2662 94.7318C18.5776 92.8984 35.8343 80.7697 56.9552 73.2386",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9584 87.2741C39.2529 84.7747 42.7029 82.4872 46.2876 80.4255",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0387 100.633C20.0387 100.633 24.9974 95.9334 31.5526 90.687",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9148 143.794C34.9148 143.794 33.0814 126.114 36.799 125.702C40.5166 125.291 43.5685 125.138 44.2398 129.149C44.2398 129.149 55.5224 133.832 57.1866 133.832C58.8507 133.832 66.5567 135.208 80.7446 130.114C80.7446 130.114 82.9503 127.767 83.6386 129.42C84.3268 131.073 84.0503 135.626 81.4328 136.861C81.7124 138.223 81.6445 139.634 81.2353 140.963C80.8262 142.292 80.089 143.496 79.0917 144.465",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2398 129.149C44.2398 129.149 40.934 130.385 39.9694 132.59",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83511 98.771C8.83511 98.771 12.1409 98.6808 12.1409 102.81C12.1409 102.81 16.276 103.775 15.4467 108.186C14.9413 111.096 14.7522 114.053 14.8826 117.004C14.8826 117.004 31.5525 126.233 35.5466 126.509",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34317 125.612C5.34317 125.612 3.04716 112.479 9.38796 112.756C9.38796 112.756 12.9702 112.192 13.241 117.162",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3224 133.279L8.69973 121.708C8.46403 122.704 8.46403 123.742 8.69973 124.738C9.11154 126.114 11.3173 126.803 11.3173 126.803L34.4466 137.549",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5932 142.508L10.2116 131.626C10.2116 131.626 9.11155 128.873 11.1763 128.873C13.241 128.873 34.7343 138.926 34.7343 138.926",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M181.12 99.1603C181.12 99.1603 187.737 112.389 198.202 105.591C208.666 98.7936 207.752 87.0371 207.752 87.0371C207.899 82.6821 207.07 79.6301 206.004 77.5259C205.241 76.0781 204.025 74.9203 202.541 74.2304C201.057 73.5405 199.388 73.3566 197.79 73.7068C181.43 77.1367 181.12 99.1603 181.12 99.1603L179.653 101.733L179.467 103.938L116.285 130.926C116.285 130.926 118.902 107.921 102.097 111.092C85.2914 114.262 83.7739 128.862 83.7739 128.862",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4695 111.283C98.4695 111.283 119.41 102.099 117.938 128.365L177.814 101.552",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M124.527 124.721L123.816 115.695C123.816 115.695 124.002 108.711 124.182 107.978C124.363 107.244 125.655 103.938 125.655 103.938L120.324 91.4373C120.324 91.4373 132.814 60.76 135.753 58.0071C135.753 58.0071 160.574 48.0897 169.369 46.0701",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M177.267 46.4481C177.267 46.4481 191.223 53.2176 194.896 71.2698",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M149.912 54.7126L141.964 58.6276C139.154 60.0126 136.928 62.3522 135.685 65.2279L131.172 75.653",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M158.16 61.5385L155.226 53.274C155.226 53.274 166.91 47.943 171.936 49.7821C176.206 51.3447 176.483 51.2037 176.483 51.2037",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M148.429 55.6321L150.082 61.1436",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M126.935 113.856L116.837 116.981",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M162.938 108.164L162.758 104.491",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6524 107.797L42.4459 117.162",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6524 109.63L42.4459 119.001",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7329 116.428L34.9148 124.879",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M129.04 84.2165C129.062 79.8809 130.6 75.6897 133.389 72.3698C135.837 69.5097 139.002 67.445 141.896 70.6097C147.684 76.9449 139.69 89.8973 139.69 89.8973C139.69 89.8973 158.701 79.1506 154.296 94.856C149.89 110.561 134.184 119.113 131.166 107.267C129.214 99.6228 128.972 90.0721 129.04 84.2165Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M141.907 70.5984C141.907 70.5984 144.113 57.6235 153.19 67.0162C158.603 72.6308 161.576 80.1584 161.46 87.9567",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M168.67 87.1274C168.105 93.6431 166.633 98.8161 164.501 99.5382C158.713 101.468 154.307 94.856 154.307 94.856",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M159.723 77.1198C159.723 77.1198 154.583 52.4166 162.848 57.6517C165.838 59.5472 167.643 65.3126 168.444 71.9806",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M172.477 58.7517C172.477 58.7517 178.542 70.3277 182.118 65.0925C185.695 59.8574 184.888 48.8344 171.665 51.593C158.442 54.3515 171.389 74.1581 177.171 75.2863",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M182.378 90.8732C178.367 94.557 172.145 94.5344 165.877 82.1631C155.407 61.499 181.306 77.7516 181.306 77.7516",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M179.377 66.7454C179.377 66.7454 186.913 75.5289 186.818 81.0687",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M133.919 83.2744C133.919 83.2744 134.483 79.4158 138.325 79.9686",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M133.919 78.3157C133.919 78.3157 137.501 80.7922 137.501 83.8272",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M144.39 98.1505C144.39 98.1505 144.954 94.2918 148.795 94.8447",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M144.39 93.1918C144.39 93.1918 147.972 95.6739 147.972 98.7033",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M109.363 133.34C110.172 126.54 107.032 120.575 102.348 120.017C97.6639 119.46 93.2104 124.52 92.4008 131.32C91.5911 138.12 94.7319 144.085 99.4158 144.642C104.1 145.2 108.553 140.14 109.363 133.34Z",
    fill: "#A16EFF",
    stroke: "#211E1F",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M195.906 101.18C199.405 101.18 202.241 96.7397 202.241 91.2625C202.241 85.7852 199.405 81.3451 195.906 81.3451C192.407 81.3451 189.571 85.7852 189.571 91.2625C189.571 96.7397 192.407 101.18 195.906 101.18Z",
    fill: "#A16EFF",
    stroke: "#211E1F",
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1931 115.875C98.1931 115.875 86.4366 116.609 87.9034 137.916",
    stroke: "#FFDE00",
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M113.622 129.832C113.622 129.832 113.25 147.1 98.9546 147.1",
    stroke: "#FFDE00",
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M191.867 78.7727C191.867 78.7727 183.405 81.3451 186.722 98.6074",
    stroke: "#FFDE00",
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M205.456 85.7509C205.456 85.7509 208.029 100.08 196.272 103.752",
    stroke: "#FFDE00",
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6614 130.204L46.8912 123.626C47.0144 122.977 47.2725 122.361 47.649 121.817C48.0254 121.274 48.5117 120.816 49.0764 120.472C49.6412 120.129 50.2717 119.908 50.9273 119.823C51.5829 119.739 52.2489 119.793 52.8823 119.982L63.1889 123.119C64.196 123.423 65.2758 123.384 66.2578 123.006L75.013 119.621C76.1472 119.184 77.4064 119.202 78.5279 119.67C79.6493 120.139 80.5465 121.023 81.0323 122.137C82.1605 124.71 83.1647 127.728 82.3749 128.715",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M101.313 138.655C103.241 138.655 104.805 136.187 104.805 133.143C104.805 130.099 103.241 127.632 101.313 127.632C99.3841 127.632 97.8207 130.099 97.8207 133.143C97.8207 136.187 99.3841 138.655 101.313 138.655Z",
    fill: "#231F20"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M195.815 96.035C197.389 96.035 198.664 94.022 198.664 91.5389C198.664 89.0557 197.389 87.0428 195.815 87.0428C194.242 87.0428 192.967 89.0557 192.967 91.5389C192.967 94.022 194.242 96.035 195.815 96.035Z",
    fill: "#231F20"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M157.957 60.6134L154.989 52.9694C154.989 52.9694 166.627 48.3492 170.621 49.5847L175.445 51.1699C175.445 51.1699 166.492 50.3462 165.798 58.6784L166.283 62.396C166.283 62.396 161.122 51.2432 157.957 60.6134Z",
    fill: "#231F20"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M143.464 80.8825C143.464 80.8825 145.399 85.5704 147.142 86.9243",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M102.785 5.30623L103.332 44.9757L130.331 51.0401L129.784 8.61202L102.785 5.30623Z",
    fill: "#A16EFF",
    stroke: "#211E1F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M129.784 8.61202L144.846 3.46717L145.58 44.9757L130.331 51.0401L129.784 8.61202Z",
    fill: "#A16EFF",
    stroke: "#211E1F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M102.785 5.30623L122.067 0.894745L144.846 3.46717L129.784 8.61202L102.785 5.30623Z",
    fill: "#A16EFF",
    stroke: "#211E1F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M116.375 23.3076C119.325 23.3076 121.717 20.2641 121.717 16.5098C121.717 12.7555 119.325 9.71207 116.375 9.71207C113.424 9.71207 111.033 12.7555 111.033 16.5098C111.033 20.2641 113.424 23.3076 116.375 23.3076Z",
    fill: "#9CFF01",
    stroke: "#211E1F",
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M116.375 21.2823C118.447 21.2823 120.126 19.1456 120.126 16.5098C120.126 13.874 118.447 11.7373 116.375 11.7373C114.303 11.7373 112.623 13.874 112.623 16.5098C112.623 19.1456 114.303 21.2823 116.375 21.2823Z",
    fill: "#231F20"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M115.642 45.066C119.907 45.066 123.364 40.6662 123.364 35.2389C123.364 29.8115 119.907 25.4118 115.642 25.4118C111.376 25.4118 107.919 29.8115 107.919 35.2389C107.919 40.6662 111.376 45.066 115.642 45.066Z",
    fill: "#9CFF01",
    stroke: "#211E1F",
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M115.642 42.1382C118.636 42.1382 121.063 39.0493 121.063 35.2389C121.063 31.4285 118.636 28.3396 115.642 28.3396C112.647 28.3396 110.22 31.4285 110.22 35.2389C110.22 39.0493 112.647 42.1382 115.642 42.1382Z",
    fill: "#231F20"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M138.737 11.7768L132.261 26.9293L137.637 26.1056L135.155 41.811L142.184 22.5234L137.913 23.3471L138.737 11.7768Z",
    fill: "#9CFF01",
    stroke: "#211E1F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M107.163 90.0327C107.163 90.0327 115.343 89.7167 116.234 81.221C116.234 81.221 117.255 89.587 125.627 89.9085C125.627 89.9085 117.323 90.6758 116.426 98.7202C116.426 98.7202 115.467 90.4163 107.163 90.0327Z",
    fill: "white",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0068 88.1033C64.0068 88.1033 79.763 83.2518 76.7336 92.3399C73.7042 101.428 52.4761 98.3987 52.4761 98.3987C51.1849 95.7097 50.7365 92.6932 51.1898 89.7449C51.9345 85.2601 55.2346 79.5511 58.6533 79.9799C61.1241 80.2563 63.2509 83.7201 64.0068 88.1033Z",
    fill: "#9CFF01",
    stroke: "#211E1F",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightCar);
export default __webpack_public_path__ + "static/media/rightCar.eda451064677c02616793146482e2a38.svg";
export { ForwardRef as ReactComponent };